import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';

import { defaultProductImg, ProductController } from '.';
import { EnumAPI } from '../../apis';
import { PointsProductVO } from '../../interface/pointsProduct';

// 积分产品兼容处理

@BindAll()
export class PointsProductController {
  Product: ProductController;
  constructor(Product) {
    this.Product = Product;
  }

  resetConfig = {
    dataKey: 'key',
    infinite: true,
    pagination: EnumAPI.product_search_points,

    details: EnumAPI.product_detail_points,
    detailsParams: {
      valueGetter: this.detailsValueGetter,
    },
    paginationParams: {
      currentKey: 'pageNo',
      pageSizeKey: 'pageSize',
      response: {
        // dataSource: 'list',
        // total: 'count',
        valueGetter: this.listValueGetter,
      },
    },
  };
  listValueGetter(res) {
    let dataSource = lodash.get(res, 'list', []);
    // 数据处理
    dataSource = dataSource.map(function (item) {
      return {
        ...item,
        key: `${item.id}-${item.providerRelId}`,
        productTags: parseProductTags(item),
        productId: item.id,
        dealerName: item.providerName,
        productImg: item.mainImageUrl || defaultProductImg,
      };
    });
    return {
      dataSource: dataSource,
      total: lodash.get(res, 'count', 0),
    };
  }

  detailsValueGetter(response: PointsProductVO) {
    lodash.assign(
      response,
      {
        // 向原接口数据结构兼容
        agreementproductId: response.id,
        channelProductType: 2,
        tradeType: 2,
        productTags: parseProductTags(response),
        dealerName: response.providerName,
        dealerId: response.providerCode,
        bomCode: response.productCode,
        productDescription: response.productDesc,
        promotionInfo: null,
      },
      {
        // 轮播图
        _SwiperImgs: parsesSwiperImgs(response),
        // 渲染内容 图片
        _ContentImgs: parsesContentImgs(response),
        // 渲染内容
        _Content: parsesContent(response),
        // 参数配置
        _Configuration: parsesConfiguration(response),
        //组合产品参数配置
        _CombinedProductParameterList: [],
        // 同系列产品
        _Series: [],
        // 当前同系列产品
        _SerieFind: {},
        //推荐产品列表
        _Recommend: [],
        //推荐产品列表
        _IsShowRecommend: false,
        // 绑定配件
        _FittingsBind: parsesFittings(response, 1),
        // 可选配件
        _FittingsOptional: parsesFittings(response, 0),
        // 弹窗图片
        _skuProductImg: parsesProductImg(response),
        // 计算价格
        _price: parsesPrices(response),
        _promotionInfo: parsePromotionInfo(response),
        //预约按钮
        _isReserve: getIsReserve(response),
        _isScore: getIsScore(response),
        productPrice: parsesPrices(response),
        productImg: getProductImg(response),
        id: getId(response),
      },
    );
    return response;
  }
}
/**
 * 解析 轮播图
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesSwiperImgs(entity: PointsProductVO) {
  const SwiperImgs = lodash.map(
    lodash.get(entity, 'carouselImagesList'),
    (i) => ({
      fileUrl: i.url,
    }),
  ) as { fileUrl: string }[];

  return lodash.isEmpty(SwiperImgs)
    ? [{ fileUrl: defaultProductImg }]
    : SwiperImgs;
}
/**
 * 解析 渲染内容 图片
 * @param {*} entity 详情数据
 * @return {*}
 */
function parsesContentImgs(entity: PointsProductVO) {
  const ContentImgs = lodash.map(
    lodash.get(entity, 'mobileDetailImagesList'),
    (i) => ({
      fileUrl: i.url,
    }),
  );
  return lodash.isEmpty(ContentImgs)
    ? [{ fileUrl: defaultProductImg }]
    : ContentImgs;
}

/**
 * 解析 渲染内容
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesContent(entity: PointsProductVO) {}

/**
 * 解析 参数配置
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesConfiguration(entity: PointsProductVO) {
  return lodash.map(lodash.get(entity, 'productAttrsList'), (i) => ({
    key: i.attrKeyName,
    value: lodash.get(i, ['attrValues', 0, 'attrValueName']),
  }));
}
/**
 * 解析 配件
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesFittings(entity, optional: 0 | 1) {
  return [];
}

/**
 * 解析 弹窗图片
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesProductImg(entity: PointsProductVO) {
  return lodash.get(entity, 'mainImageUrl') || defaultProductImg;
}

/**
 * 解析 重新计算价格
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsesPrices(entity: PointsProductVO) {
  return entity.price;
}

/**
 * 解析 活动信息
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parsePromotionInfo(entity: PointsProductVO) {
  return null;
}

/**
 * 解析 结算订单时的展示图片
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function getProductImg(entity: PointsProductVO) {
  let imgList = parsesSwiperImgs(entity);
  return imgList && imgList.length ? imgList[0].fileUrl : defaultProductImg;
}

function getIsReserve(entity) {
  const { buttonList } = entity;
  return lodash.includes(buttonList, 6);
}

function getIsScore(entity) {
  return true;
}

function getId(entity) {
  return lodash.get(entity, 'id');
}

/**
 * 解析 标签
 * @param {*} entity 详情数据
 * @return {*}
 * @memberof ProductController
 */
function parseProductTags(item) {
  try {
    let productTags = item.productTagsList || [];
    return productTags.map((i) => i.attrValueName);
  } catch (error) {
    console.log('🚀 ~ productSearch.js:130 ~ error:', error);
    return [];
  }
}
